function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.750244 0.291559L0.750244 6.70844C0.750266 6.76156 0.764794 6.81367 0.792261 6.85914C0.819727 6.90461 0.85909 6.94171 0.9061 6.96645C0.953111 6.99118 1.00598 7.00261 1.05901 6.9995C1.11204 6.99639 1.16322 6.97885 1.20701 6.94878L5.87383 3.74034C5.91282 3.71354 5.94469 3.67765 5.96672 3.63578C5.98874 3.59391 6.00025 3.54731 6.00025 3.5C6.00025 3.45269 5.98874 3.40609 5.96672 3.36422C5.94469 3.32235 5.91282 3.28646 5.87383 3.25966L1.20701 0.0512175C1.16322 0.021151 1.11204 0.00361441 1.05901 0.000501142C1.00598 -0.00261165 0.953111 0.00881671 0.9061 0.0335526C0.85909 0.058289 0.819727 0.0953932 0.79226 0.140862C0.764793 0.186331 0.750265 0.238438 0.750244 0.291559Z"
});

const SvgLoadMoreArrow = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLoadMoreArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/load_more_arrow.e7419de6.svg";
export { ForwardRef as ReactComponent };